import * as React from "react";

export const AuthUserContext = React.createContext(null);



// WEBPACK FOOTER //
// ./src/firebase/AuthUserContext.ts